/* eslint-disable react-hooks/exhaustive-deps */
import '../../../../assets/css/dealspace_directory.css';

import { Icons } from '@Assets/SvgIcons';
import ColorPicker from '@components/UI/ColorPicker/ColorPicker';
import { RootAssets } from '@Config/rootAssets';
import { ComponentHelper, useEffectAsync, UserHelper } from '@Helper/Infra';
import { DealProjectDTO, NewDealProjectDTO } from '@Helper/Interfaces';
import { MergefloServices } from '@Helper/MergefloServices';
import { Button, Dialog, InputBase, MenuItem, Select } from '@mui/material';
import {
  getAssetsFunctionalAreas,
  postAssets,
} from '@Store/feature/assetsSlice';
import {
  getFunctionalareatype,
  patchPurePlaybook,
  postPurePlaybook,
} from '@Store/feature/purePlaybookSlice';
import { useAppDispatch, useAppSelector } from '@Store/hooks';
import { SelectedInvitetoDealItem } from 'pages/DealspaceDirectory/model';
import React, { FC, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

type Props = {
  onClose: () => void;
  selectedWorkStream?: SelectedInvitetoDealItem | null;
  setAddWorkStreams?: (item: DealProjectDTO) => void;
  addPersonModalOpen?: (item: DealProjectDTO) => void;
};

const WorkStreamModal: FC<Props> = ({
  onClose,
  selectedWorkStream,
  setAddWorkStreams,
  addPersonModalOpen,
}) => {
  const [newWorkstreamsCard, setNewWorkstreamsCard] = useState<string>('');
  const [functionalAreaTypeId, setFunctionalAreaTypeId] = useState<string>('');
  const [newPrefix, setNewPrefix] = useState<string>('');
  const [existingPrefix, setExistingPrefix] = useState<string>('');
  const [hasError, setHasError] = useState(false);
  const [existingPrefixes, setExistingPrefixes] = useState<string[]>([]);
  const { id } = useParams();
  const [newWorkstreamsCardColor, setNewWorkstreamsCardColor] =
    useState<string>('#1a7d77');
  const componentHelper = new ComponentHelper();
  const mergefloService = new MergefloServices();
  const functionalAreas = useAppSelector(getAssetsFunctionalAreas);
  const dispatch = useAppDispatch();

  const [functionalareatype, setFunctionalareatype] = useState([]);

  useEffectAsync(async () => {
    if (selectedWorkStream) {
      const selectedPlaybook = await mergefloService.retrievePlaybook(
        selectedWorkStream.item.project?.id || ''
      );
      setNewPrefix(selectedPlaybook?.project?.taskPrefix ?? '');
      setExistingPrefix(selectedPlaybook?.project?.taskPrefix ?? '');

      console.log('selectedPlaybook', selectedPlaybook);
    }
  }, [selectedWorkStream]);

  useEffectAsync(async () => {
    if (id) {
      const prefixResponse = await componentHelper.getDealspacePrefixes(id);
      setExistingPrefixes(prefixResponse);
    }
  }, [id]);

  useEffect(() => {
    if (selectedWorkStream?.operation === 'update') {
      setNewWorkstreamsCard(selectedWorkStream.item.project?.name || '');
      setNewWorkstreamsCardColor(
        selectedWorkStream.item.functionalArea?.color || '#1a7d77'
      );
      setFunctionalAreaTypeId(
        selectedWorkStream?.item.functionalArea?.functionalAreaTypeId || ''
      );
    }
    dispatch(getFunctionalareatype()).then(res =>
      setFunctionalareatype(res.payload)
    );
  }, [selectedWorkStream]);

  React.useEffect(() => {
    if (existingPrefixes.includes(newPrefix) && existingPrefix !== newPrefix) {
      setHasError(true);
    }
    if (existingPrefix === newPrefix && selectedWorkStream) {
      setHasError(false);
    }
  }, [newPrefix, selectedWorkStream, existingPrefix]);

  const addWorkStream = async (type: string) => {
    if (newWorkstreamsCard.length < 1) {
      toast(
        'Please select a valid name, name length must be bigger than 1 characters'
      );
      return;
    }
    const newPlaybook = {
      name: newWorkstreamsCard,
      dealspaceId: id,
      taskPrefix: newPrefix,
      functionalArea: {
        name: newWorkstreamsCard,
        shortName: newPrefix,
        color: newWorkstreamsCardColor,
        functionalAreaTypeId: functionalAreaTypeId,
      },
    } as NewDealProjectDTO;

    const data = {
      playBook: newPlaybook,
      initialID: id || '',
    };
    if (type === 'people') {
      dispatch(postPurePlaybook(data)).then(async item => {
        if (addPersonModalOpen) {
          onClose();
          addPersonModalOpen(item.payload as DealProjectDTO);
        } else {
          onClose();
        }

        const userHelper = new UserHelper();
        const haveDealspace = await userHelper.getAssets();
        dispatch(postAssets(haveDealspace as RootAssets));
      });
    } else {
      dispatch(postPurePlaybook(data));
      onClose();
    }
  };

  const updateWorkStream = async () => {
    if (newWorkstreamsCard.length < 3) {
      toast(
        'Please select a valid name, name length must be bigger than 3 characters'
      );
      return;
    }

    const newPlaybook = {
      name: newWorkstreamsCard,
      taskPrefix: newPrefix,
      functionalArea: {
        name: newWorkstreamsCard,
        shortName: newPrefix,
        color: newWorkstreamsCardColor,
      },
    } as NewDealProjectDTO;

    const data = {
      playBook: newPlaybook,
      initialID: selectedWorkStream?.item.id || '',
    };

    dispatch(patchPurePlaybook(data));

    onClose();
  };

  return (
    <Dialog
      open={true}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="WorkstreamsCard-func-dialog"
    >
      <div className="dialog-header">
        <div className="dialog-title">
          {selectedWorkStream ? 'Update' : 'Add New'} Workstream
        </div>
        <button className="dialog-close-button" onClick={onClose}>
          <Icons.Cancel color="#000000" />
        </button>
      </div>
      <div className="dialog-content">
        <div className="dialogDescription">
          <div className="taskDetailDescriptionHead">
            Type the name for the workstream{' '}
          </div>
          <div className="editTaskName">
            <InputBase
              value={newWorkstreamsCard}
              onChange={evt => {
                setHasError(false);
                setNewWorkstreamsCard(evt.target.value);
                const currentText = evt.target.value as string;
                if (selectedWorkStream?.operation !== 'update') {
                  if (currentText.length >= 2) {
                    const initialPrefix = (
                      currentText[0] +
                      currentText[1] +
                      (currentText.length >= 3 ? currentText[2] : 'T')
                    ).toUpperCase();
                    setNewPrefix(initialPrefix);
                    if (
                      existingPrefixes.includes(initialPrefix) &&
                      newPrefix !== existingPrefix
                    ) {
                      setHasError(true);
                    }
                  } else {
                    setNewPrefix('');
                  }
                }
              }}
              placeholder="Enter the name of your workstream"
              style={{ width: '100%' }}
            />
            <ColorPicker
              color={newWorkstreamsCardColor}
              onChange={e => setNewWorkstreamsCardColor(e)}
            />
          </div>
        </div>
        <div className="dialogDescription">
          <div className="taskDetailDescriptionHead">Function area type </div>

          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={functionalAreaTypeId}
            label="Age"
            className="customOutlinedInput"
            onChange={e => {
              setHasError(false);
              setFunctionalAreaTypeId(e.target.value);
            }}
          >
            {functionalareatype.map(({ id, name }) => (
              <MenuItem key={id} value={id}>
                {name}
              </MenuItem>
            ))}
          </Select>
        </div>
        <div className="dialogDescription">
          <div className="taskDetailDescriptionHead">
            This is your task prefix{' '}
          </div>
          <div className="editTaskName">
            <InputBase
              value={newPrefix}
              onChange={evt => {
                setHasError(false);
                const text = evt.target.value;
                setNewPrefix(text.toUpperCase());
              }}
              placeholder=""
              inputProps={{ maxLength: 3 }}
              style={{ width: '100%' }}
            />
          </div>
        </div>
        {hasError && (
          <div className="dialogDescription">
            <div className="taskDetailDescriptionHead" style={{ color: 'red' }}>
              This prefix is already in use.
            </div>
          </div>
        )}
      </div>
      <div className="dialog-footer">
        {selectedWorkStream ? (
          <Button
            className="FuchsiaBlueButton"
            style={{ width: 233 }}
            onClick={() => updateWorkStream()}
          >
            <span>Update workstream</span>
          </Button>
        ) : (
          <React.Fragment>
            {setAddWorkStreams && (
              <Button
                onClick={async () => addWorkStream('people')}
                className="FuchsiaBlueButton"
                disabled={hasError}
                style={{
                  width: 240,
                  marginRight: '10px',
                  background: 'rgb(232, 230, 255)',
                  color: 'rgb(48, 37, 155)',
                }}
              >
                <span>Add Workstream & Invite People</span>
              </Button>
            )}
            <Button
              onClick={async () => addWorkStream('workstream')}
              className="FuchsiaBlueButton"
              disabled={hasError}
              style={{ width: 'auto', padding: '6px 12px 6px 12px' }}
            >
              <span>Add Workstream</span>
            </Button>
          </React.Fragment>
        )}
      </div>
    </Dialog>
  );
};

export default WorkStreamModal;
